import { render, staticRenderFns } from "./accountSetting.vue?vue&type=template&id=74357605&scoped=true&"
import script from "./accountSetting.vue?vue&type=script&lang=js&"
export * from "./accountSetting.vue?vue&type=script&lang=js&"
import style0 from "./accountSetting.vue?vue&type=style&index=0&id=74357605&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74357605",
  null
  
)

component.options.__file = "accountSetting.vue"
export default component.exports